import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "roleSelect", "adminWarning", "modalDescription"]
  static values = {
    currentRoleId: String,
  }

  connect() {
    this.originalRoleId = this.roleSelectTarget.value
  }

  submitForm(event) {
    event.preventDefault()

    const newRoleId = this.roleSelectTarget.value

    // Show confirmation if role has actually changed
    if (newRoleId !== this.originalRoleId) {
      const selectedOption = this.roleSelectTarget.querySelector(`option[value="${newRoleId}"]`)
      const isRemovingAdmin = this.isRoleDowngrade(newRoleId)

      this.updateModalContent(selectedOption.text, isRemovingAdmin)
      this.dialogTarget.showModal()
    }
  }

  isRoleDowngrade(newRoleId) {
    const currentOption = this.roleSelectTarget.querySelector(
      `option[value="${this.originalRoleId}"]`,
    )
    const newOption = this.roleSelectTarget.querySelector(`option[value="${newRoleId}"]`)

    const currentIsAdmin = currentOption && currentOption.dataset.admin === "true"
    const newIsAdmin = newOption && newOption.dataset.admin === "true"

    return currentIsAdmin && !newIsAdmin
  }

  updateModalContent(newRoleName, isRemovingAdmin) {
    if (this.hasModalDescriptionTarget) {
      const template = this.modalDescriptionTarget.getAttribute("data-modal-description")
      this.modalDescriptionTarget.textContent = template.replace("{{role}}", newRoleName)
    }

    if (this.hasAdminWarningTarget) {
      this.adminWarningTarget.classList.toggle("hidden", !isRemovingAdmin)
    }
  }

  confirm() {
    this.submitFormActually()
  }

  submitFormActually() {
    const form = this.element.querySelector("form")
    if (form) {
      form.requestSubmit()
    }
  }

  cancel() {
    this.roleSelectTarget.value = this.originalRoleId
    this.dialogTarget.close()
  }

  // Close on backdrop click
  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.cancel()
    }
  }

  // Close on Escape key
  keydown(event) {
    if (event.key === "Escape") {
      this.cancel()
    }
  }
}
